import { Component, Input, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { DashboardService } from 'src/app/shared/services/dashboardservices/dashboard.service';
import { calculateUpdatedTime } from '../../shift-time';
import { DataSharingService } from '../../data-sharing.service';
import { AttendanceService } from 'src/app/shared/services/attendanceservices/attendance.service';
import { SharedModeService } from 'src/app/shared/services/shared-mode.service';
import { CommonModule } from '@angular/common';


@Component({
  selector: 'attendance-type',
  templateUrl: './attendance-type.component.html',
  standalone: true,
  imports: [RouterModule, CommonModule]
})
export class AttendanceTypeComponent implements OnInit {

  @Input() type!: any;
  @Input() paidLeaves!: any;
  @Input() unpaidLeaves!: any;
  public userid: any;
  public user: any = [];
  public data: any = 'red';
  public checkin: any = ''
  public checkout: any = ''
  public backgroundColor: any;
  public titleColor: any;
  public titleColortwo: any;
  public titleColorthree: any;
  public attendanceType: any[] = [];
  public noOfRequest: any;
  public status: any;
  getdata: any;


  attendanceRequest: any;
  attendance_id: any;
  id: any;
  showSpinner: any;
  userInfo: any;
  colormode: any;
  selectedMode: any;
  datamode: any;
  workingHours: any;
  shiftStartTime: any;
  shiftEndTime: any;
  totalWorkingHours: any;
  latestShiftstarttime: any;
  latestShiftendtime: any;
  latestShifthours: any;
  latestShiftoffday: any;
  offday: any;
  constructor(
    private attendanceService: AttendanceService,
    public dashboardService: DashboardService,
    private dataSharingService: DataSharingService,
    private sharedmode: SharedModeService,

    private router: Router
  ) {

    this.user = JSON.parse(localStorage.getItem('user') || '');

  }

  ngOnInit(): void {

    this.sharedmode.data$.subscribe(mode => {
      this.selectedMode = mode;

    });

    this.getAttandaceDetails();
  }

  senddata: any = { user_id: '', attendance_id: '', date: '', checkin: '', checkout: '', workinghour: '', overtime: '' };

  // munib data send to other component
  sendDataToReceiver() {
    this.senddata.user_id = this.type.data[0].user_id;
    this.senddata.attendance_id = this.type.data[0].id;
    this.senddata.date = this.type.data[0].date;
    this.senddata.checkin = this.type.data[0].check_in;
    this.senddata.checkout = this.type.data[0].check_out;

    this.senddata.workinghour = this.type.data[0].total_hours;
    this.senddata.overtime = this.type.data[0].overtime;
    const dataToSend = this.senddata; // Replace with your data

    // const dataToSend = this.type.data[0].check_in; // Replace with your data
    this.dataSharingService.setSharedData(dataToSend);
    this.getAttendanceData();

  }

  isOverTime() {
    if (this.type?.data[0]?.overtime != 0 && this.type.data[0]?.overtime > 0) {
      return true
    } else {
      return false
    }
  }


  getAttendanceData() {
    this.attendanceService.getrequest().then((value) => {
      this.attendanceRequest = value.data
    });


  }


  btnok(id: any) {
    this.router.navigate(['/user-attendance-requests', id]);
  }


  getAttandaceDetails() {
    //munib data check number of request and status
    this.checkin = this.type.data[0].check_in
    this.id = this.type.data[0].id
    this.userid = this.type.data[0].user_id
    this.checkout = this.type.data[0].check_out
    this.noOfRequest = this.type.data[0].no_of_request ?? ''
    this.status = this.type.data[0].request_status ?? ''
    this.workingHours = this.type.total_hours
    this.shiftStartTime = this.type.data[0].shift_start_time
    this.shiftEndTime = this.type.data[0].shift_end_time
    this.totalWorkingHours = this.type.data[0].total_working_hours
    this.latestShiftoffday = this.type.data[0].off_day




    // var workingHours = 6
    const date = this.type.data[0].date
    const leaveCheckDate = date.replace(new RegExp('/', 'g'), '-')

    const dateOBJ = new Date(date);
    // if(workingHours.length == 1){
    // }

    if (this.user.last_working_date < leaveCheckDate) {
      var att_type: Record<string, string> = {
      }
      att_type["title"] = "OFF Day";
      att_type["color"] = "#2180FF";

      this.attendanceType.push(att_type);

      this.backgroundColor = "#DBEAFF";
      this.titleColor = "#2180FF";
      this.titleColortwo = "#2180FF";
    } else if (this.user.joining_date > leaveCheckDate) {
      //  Weekend Before Joining
      var att_type: Record<string, string> = {
      }
      att_type["title"] = "OFF Day";
      att_type["color"] = "#2180FF";
      this.attendanceType.push(att_type);
      if (this.selectedMode == "dark") {
        this.backgroundColor = "#333952";
      } else {
        this.backgroundColor = "#DBEAFF";
      }
      this.titleColor = "#2180FF";
      this.titleColortwo = "#2180FF";
      this.titleColorthree = "#2180FF";
    } else if (dateOBJ.getDay() == 0
      && (this.checkin ?? '').length == 0
      && (this.checkout ?? '').length == 0
      && this.latestShiftoffday == null) {
      //  Weekend (Sunday)
      var att_type: Record<string, string> = {
      }
      att_type["title"] = "Weekend";
      att_type["color"] = "#2180FF";
      att_type["bgcolor"] = "#DBEAFF";
      att_type["fontsize"] = "0.9rem";

      this.attendanceType.push(att_type);
      if (this.selectedMode == "dark") {
        this.backgroundColor = "#333952";
      } else {
        this.backgroundColor = "#DBEAFF";
      }
      this.titleColor = "#2180FF";
      this.titleColortwo = "#2180FF";
      this.titleColorthree = "#2180FF";

    } else if (dateOBJ.getDay() == 6
      && (this.checkin ?? '').length == 0
      && (this.checkout ?? '').length == 0
      && this.latestShiftoffday == null) {
      //  Weekend (Saturday)
      var att_type: Record<string, string> = {
      }
      att_type["title"] = "Weekend";
      att_type["color"] = "#2180FF";
      att_type["bgcolor"] = "#DBEAFF";
      att_type["fontsize"] = "0.9rem";
      this.attendanceType.push(att_type);
      if (this.selectedMode == "dark") {
        this.backgroundColor = "#333952";
      } else {
        this.backgroundColor = "#DBEAFF";
      }
      this.titleColor = "#2180FF";
      this.titleColortwo = "#2180FF";
      this.titleColorthree = "#2180FF";
    } else if (this.latestShiftoffday == 1
      && (this.checkin ?? '').length == 0
      && (this.checkout ?? '').length == 0) {
      var att_type: Record<string, string> = {
      }
      att_type["title"] = "Off Day";
      att_type["color"] = "#2180FF";
      att_type["bgcolor"] = "#DBEAFF";
      att_type["fontsize"] = "0.9rem";

      this.attendanceType.push(att_type);
      if (this.selectedMode == "dark") {
        this.backgroundColor = "#333952";
      } else {
        this.backgroundColor = "#DBEAFF";
      }
      this.titleColor = "#2180FF";
      this.titleColortwo = "#2180FF";
      this.titleColorthree = "#2180FF";
    } else if (
      this.dashboardService.otherOffDays.includes(date)
    ) {
      // Weekend

      var att_type: Record<string, string> = {
      }
      const title = this.dashboardService.otherOffDaysvalue[this.dashboardService.otherOffDays.indexOf(date)]
      att_type["title"] = title;
      att_type["color"] = "#0E990B";
      att_type["fontsize"] = "0.9rem";
      this.attendanceType.push(att_type);
      if (this.selectedMode == "dark") {
        this.backgroundColor = "#333952";
      } else {
        this.backgroundColor = "#EDFFED";
      }
      this.titleColor = "#0E990B";
      this.titleColortwo = "#0E990B";
      this.titleColorthree = "#0E990B";
    } else if (this.paidLeaves.includes(leaveCheckDate)) {
      //  Paid Leave (Approved)
      var att_type: Record<string, string> = {
      }
      att_type["title"] = "Paid Leave";
      att_type["color"] = "#EDFFED";
      att_type["bgcolortitle"] = "green";
      att_type["bdrcolor"] = "1px solid #03670D";
      this.attendanceType.push(att_type);
      if (this.selectedMode == "dark") {
        this.backgroundColor = "#333952";
      } else {
        this.backgroundColor = "#EDFFED";

      }
      this.titleColor = "#0E990B";
      this.titleColortwo = "#0E990B";
      this.titleColorthree = "#0E990B";
    } else if (this.unpaidLeaves.includes(leaveCheckDate)) {
      //  Un Paid Leave (Approved)
      var att_type: Record<string, string> = {
      }
      att_type["title"] = "Un Paid Leave";
      att_type["color"] = "#f595a7";
      att_type["bgcolor"] = "#FFE8EB";
      att_type["bdrcolor"] = "1px solid #DD011D";
      this.attendanceType.push(att_type);

      this.titleColor = "#f595a7";
      this.titleColortwo = "#f595a7";
      this.titleColorthree = "#f595a7";
    } else if ((this.checkin ?? '').length == 0 && (this.checkout ?? '').length == 0) {
      // Absent
      var att_type: Record<string, string> = {
      }
      att_type["title"] = "Absent";
      att_type["color"] = "#FFFFFF";
      att_type["bgcolor"] = "#DD011D";
      att_type["bgcolortitle"] = "#DD011D";
      att_type["bdrcolor"] = "1px solid #DD011D";
      this.attendanceType.push(att_type);
      if (this.selectedMode == "dark") {
        this.backgroundColor = "#333952";
      } else {
        this.backgroundColor = "#FFE8EB";
      }
      this.titleColor = "#DD011D";
      this.titleColortwo = "#DD011D";
      this.titleColorthree = "#DD011D";
    } else {
      // assigning total hours
      let perDayWorkingHour = this.totalWorkingHours;
      // --------------- just Ramzan ------------------
      const ramzanDateStart = new Date("2026/02/19");
      const ramzanDateEnd = new Date("2026/03/20");
      if (dateOBJ > ramzanDateStart && dateOBJ < ramzanDateEnd) {
        perDayWorkingHour = 7.0;
      }
      // --------------- just Ramzan ------------------

      if ((this.checkin ?? '').length == 0) {
        //Check in Miss
        var att_type: Record<string, string> = {
        }
        att_type["title"] = "Check In Missing";
        att_type["color"] = "#EB5F8C";
        att_type["bgcolortitle"] = "#FFC5D7";
        att_type["bdrcolor"] = "1px solid #EB5F8C";
        this.attendanceType.push(att_type);
        this.titleColortwo = "#FFB700";

        var att_type: Record<string, string> = {
        }
        att_type["title"] = "Short Time";
        att_type["color"] = "#AB7C05";
        att_type["bgcolortitle"] = "#FFEDC0";
        att_type["bdrcolor"] = "1px solid #FFB700";
        if (this.latestShiftoffday != 1) {
          this.attendanceType.push(att_type);
        }
      }

      if ((this.checkout ?? '').length == 0) {
        //Check Out Miss
        var att_type: Record<string, string> = {
        }
        att_type["title"] = "Check Out Missing";
        att_type["color"] = "#175F87";
        att_type["bgcolortitle"] = "#BAE6FF";
        att_type["bdrcolor"] = "1px solid #175F87";
        this.attendanceType.push(att_type);

        var att_type: Record<string, string> = {
        }
        att_type["title"] = "Short Time";
        att_type["color"] = "#AB7C05";
        att_type["bgcolortitle"] = "#FFEDC0";
        att_type["bdrcolor"] = "1px solid #FFB700";
        if (this.latestShiftoffday != 1) {
          this.attendanceType.push(att_type);
        }
      }

      if (this.workingHours > 0 && this.workingHours < perDayWorkingHour) {
        var att_type: Record<string, string> = {
        }
        att_type["title"] = "Short Time";
        att_type["color"] = "#AB7C05";
        att_type["bgcolortitle"] = "#FFEDC0";
        att_type["bdrcolor"] = "1px solid #FFB700";
        if (this.latestShiftoffday != 1) {
          this.attendanceType.push(att_type);
        }
        this.titleColortwo = "#FFB700";
        this.titleColorthree = "#FFB700";
      }

      if (this.latestShiftoffday == 1) {
        var att_type: Record<string, string> = {
        }
        att_type["title"] = "Off Day";
        att_type["color"] = "#2180FF";
        att_type["bgcolor"] = "#DBEAFF";
        att_type["fontsize"] = "0.9rem";

        this.attendanceType.push(att_type);
        if (this.selectedMode == "dark") {
          this.backgroundColor = "#333952";
        } else {
          this.backgroundColor = "#DBEAFF";
        }
        this.titleColor = "#2180FF";
        this.titleColortwo = "#2180FF";
        this.titleColorthree = "#2180FF";

      }


      if (this.user.attandance_type != "BD_OPEN") {
        const initialTime = this.shiftStartTime;
        const startTimeLimit = calculateUpdatedTime(initialTime);
        if (this.checkin <= startTimeLimit && this.workingHours > 0 && this.workingHours >= perDayWorkingHour) {
          var att_type: Record<string, string> = {
          }
          att_type["title"] = "All Good";
          att_type["color"] = "#03670D";
          att_type["bgcolortitle"] = "#BCFFC3";
          att_type["bdrcolor"] = "1px solid #03670D";
          this.attendanceType.push(att_type);
          this.titleColor = "#4EB053";
          this.titleColortwo = "#4EB053";
          this.titleColorthree = "#4EB053";
        }
        else if (this.checkin > startTimeLimit) {
          //Check In Late
          var att_type: Record<string, string> = {
          }
          att_type["title"] = "Check In Late";
          att_type["color"] = "#ED0B53";
          att_type["bgcolortitle"] = "#FFC5D7";
          att_type["bdrcolor"] = "1px solid #EB5F8C";
          this.attendanceType.push(att_type);
          this.titleColor = "#f595a7";
        }
        if (this.checkin > startTimeLimit && this.workingHours < perDayWorkingHour) {
          //Check In Late and wokring hour less
          this.titleColor = "#f595a7";
          this.titleColortwo = "#FFB700";
          this.titleColorthree = "#FFB700";
        }
        if (this.checkin > startTimeLimit && this.workingHours >= perDayWorkingHour) {
          //Check In Late and working hour complete
          this.titleColor = "#f595a7";
          this.titleColortwo = "#4EB053";
          this.titleColorthree = "#4EB053";
        }
        if (this.checkin < startTimeLimit && this.workingHours < perDayWorkingHour) {
          //Check In on time and working hour not complete
          this.titleColor = "#4EB053";
          this.titleColortwo = "#FFB700";
          this.titleColorthree = "#FFB700";
        }
        if (this.checkin < startTimeLimit && (this.checkout ?? '').length == 0) {
          //Check In on time and check out miss
          this.titleColor = "#4EB053";
          this.titleColortwo = "#FFB700";
          this.titleColorthree = "#FFB700";
        }
        if (this.checkin > startTimeLimit && (this.checkout ?? '').length == 0) {
          //Check In Late and check out miss
          this.titleColor = "#f595a7";
          this.titleColortwo = "#FFB700";
          this.titleColorthree = "#FFB700";
        }
      } else {
        if (this.attendanceType.length == 0) {
          var att_type: Record<string, string> = {
          }
          att_type["title"] = "All Good";
          att_type["color"] = "#03670D";
          att_type["bgcolortitle"] = "#BCFFC3";
          att_type["bdrcolor"] = "1px solid #03670D";
          this.attendanceType.push(att_type);
          this.titleColor = "#4EB053";
          this.titleColortwo = "#4EB053";
          this.titleColorthree = "#4EB053";
        }
      }
    }
  }

  getAttendanceColour(data: any) {
    if (data == 'Check In Late') {
      return '#EB5F8C';
    }
    if (data == 'Check In Miss') {
      return '#FB908F';
    }
    if (data == 'Check Out Miss') {
      return '#175F87';
    }
    if (data == 'Leave') {
      return '#FD7171';
    }
    if (data == 'Short Leave') {
      return '#478AD1';
    }
    if (data == 'Normal') {
      return 'white';
    }
    if (data == 'Absent') {
      return '#DD011D';
    }

    if (data == 'Weekend') {
      return '#2180FF';
    }

    if (data == 'Short Hours') {
      return '#E6991C';
    }

    return '';
  }

  user_detail() {
    this.showSpinner = true;
    this.dashboardService.getuserdetail().then((value) => {
      this.userInfo = value.data
      this.colormode = this.userInfo.color_mode
      this.sharedmode.setMode(this.colormode);
      this.showSpinner = false;
    })

  }

}
